/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { PageStyle } from "@insite/mobius/Page";
import {getProp} from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { xBaseTheme } from "@monsma/XDL/types";
import { css } from "styled-components";

export default {
    css: css`
        body {
            font-family: "Inter", sans-serif;
            background: ${getColor("common.ui11")};

            * {
                &:focus {
                    outline: 0 !important;
                }
            }

            &:after {
                transition: all 0.2s linear;
                content: "";
                position: fixed;
                top: 0;
                left: 0;
                z-index: ${getProp("theme.zIndex.shade")};
                width: 100%;
                height: 100%;
                pointer-events: none;
            }

            &.shade {
                &:after {
                    background-color: rgba(0, 0, 0, 0.7);
                }
            }
        }

        @media print {
            ${PageStyle}, html, body {
                background: ${getColor("common.background")};
            }

            * {
                color-adjust: exact;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
            }

            @page {
                size: auto;
                margin: 30px 15px;
            }

            h1 {
                font-size: 28px !important;
            }

            body {
                & {
                    font-size: 15px !important;
                }
            }

            h3,
            h6 {
                font-size: 18px !important;
            }
        }

      div[data-test-selector="page_CheckoutReviewAndSubmitPage"],
      div[data-test-selector="page_CheckoutShippingPage"],
      div[data-test-selector="page_CheckoutReviewAndSubmitPage"] {
        min-height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        > main {
            display: flex;
            flex: 1;
        }
      }
    `,
} as xBaseTheme["globalStyle"];
